@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";
@use "ui/oldStyles/variables/spacing";
@use "ui/oldStyles/symbols";
@use "ui/oldStyles/utils";

// TODO: The styles in this file should be refactored
.wrapper {
  position: relative;

  :global {
    .required-fields-indicator {
      font-size: 12px;
      margin-bottom: 10px;
      display: block;
      font-weight: 400;

      &:before {
        content: "*";
        color: colorsOld.$ruby;
        margin-right: 4px;
      }
    }

    .two-column {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;

      > * {
        flex: 1;
      }
    }

    .modal-body {
      margin-top: 24px;
      font-size: fontsOld.$small;
      color: colorsOld.$stoneDarkX1;
    }

    .confirmation {
      strong {
        font-weight: fontsOld.$medium-weight;
      }

      .confirmation-input {
        margin-top: 24px;
      }
    }

    .table-container {
      max-height: 250px;
      overflow-y: scroll;
    }

    .modal-footer {
      display: flex;
      margin-top: 48px;
      margin-bottom: -12px;
      position: relative;

      .footer-divider {
        position: absolute;
        top: -24px;
        left: -36px;
        right: -36px;
        height: 1px;
        background-color: colorsOld.$stoneLightX1;
      }

      .footer-left {
        flex: 1;
      }

      .footer-right {
        display: flex;
        gap: 16px;
      }
    }
  }
}

.fieldWrapper {
  margin: 0.5em 0;

  &:first-of-type {
    margin-top: 0;
  }
}

.checkboxes {
  display: flex;
  margin-top: 12px;
}

.checkbox {
  margin-right: 12px;
}